<template>
  <div>

    <div class="icons">
      <van-icon name="info-o" />
      <p>您可根据需要，自愿选择加项。</p>
    </div>

    <div class="AddProduct-context">
      <van-checkbox-group v-model="result">
        <van-cell-group v-for="(item,index) in list"  :key="index" >
          <h2 class="title" >{{ item.itemTypeName }}</h2>
          <van-cell
              v-for="(items, indexs) in item.itemList"
              clickable
              :value="'￥' + items.itemPrice"
              :key="indexs"
              @click="toggle(items.itemId)"
          >
            <template #title>
              <van-checkbox :name="items.itemId" :ref="'checkboxes' + items.itemId" >
                <template>
                  <span>{{ items.itemName }}</span>
                  <van-icon @click.stop="seeDeta(items)" name="info" />
                </template>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>

  </div>
</template>

<script>
export default {
  name: "AddProduct",
  data() {
    return {
      list: [],
      result: []
    }
  },
  created() {


    this.$store.dispatch("setItemPlusType");
    this.getList(this.$route.query.id);
  },
  methods: {
    toggle(id) {

      this.$refs["checkboxes"+id][0].toggle();

      setTimeout(() => {

        let flag= this.result.includes(id);

        let obj= {};
        obj["plusItemId"]=  flag ? id : null;
        obj["productId"]= this.$route.query.id;
        obj["selectedPlusItemList"]= this.result;
        obj["cardFlag"]= !JSON.parse(this.$route.query.isMake);


        this.$post("product/item/plus",obj)
          .then(res => {

            if(res.code === "SUCCESS") {
              this.$emit("update:price",res.data.toString());
              this.$emit('update:plusItemList', this.result);
            }else {
              let index= this.result.indexOf(id);
              this.result.splice(index,1);

            }

          })

      },100)

    },
    getList(y) {

      this.$get("product/"+ y +"/plus-item")
        .then(res => {
          if(res) {
            // console.log(res.data);
            // console.log(this.$store.state.itemPlusType);
            this.list= res.data;

            console.log(this.list)
            this.$emit('listAddProduct',this.list)

            if(this.list.length == 0) {
              console.log(1)

              this.$emit('isAddProduct',1)
            }else {
              let active= this.$route.query.isMakeOrder ? 1 : 0
              console.log(active)

              this.$emit('isAddProduct',active)
            }

          }
        })

    },
    seeDeta(e) {

      this.$dialog.alert({
        title: e.itemName,
        message: e.itemDesc,
      }).then(() => {
        // on close
      });

    },
  },
  props: {
    plusItemList: {
      type: Array,
      default() {
        return []
      }
    },
    price: {
      type: String,
    }
  },
}
</script>

<style lang="scss" scoped>
 @import "../../style/Make/AddProduct";
</style>
